export default __webpack_public_path__ + "static/media/zpdwue.a08ca892.png";